import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { strengthsLabel, priceLabel } from "../lib/product";
import { Search } from "lucide-react";
import { ProductImage, primaryImageId } from "../components/ProductImage";
import { Watermark, Eyebrow } from "../components/Botanical";

export default function Shop() {
  const [params, setParams] = useSearchParams();
  const q = params.get("q") || "";
  const [products, setProducts] = useState([]);
  const [search, setSearch] = useState(q);

  useEffect(() => {
    api.get("/products", { params: q ? { q, category: "research" } : { category: "research" } }).then((r) => setProducts(r.data || []));
  }, [q]);

  const onSearch = (e) => {
    e.preventDefault();
    setParams(search.trim() ? { q: search.trim() } : {});
  };

  return (
    <div className="relative overflow-x-clip" data-testid="shop-page">
    <Watermark opacity={0.32} height="h-[220px] sm:h-[250px]" testid="shop-watermark" />
    <div className="relative max-w-7xl mx-auto px-6 lg:px-8 py-16">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10">
        <div>
          <Eyebrow>Research catalog</Eyebrow>
          <h1 className="font-serif text-5xl mt-2">Shop</h1>
          <p className="text-sm text-[#5E4D5A] mt-2 max-w-md">Research use only. Not for human or animal consumption.</p>
        </div>
        <form onSubmit={onSearch} className="flex items-center bg-white rounded-full px-5 py-3 border border-[#A8B59A]/30 w-full md:w-80">
          <Search size={16} className="text-[#5E6B51] mr-3" />
          <input data-testid="shop-search" value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search by name…" className="bg-transparent outline-none text-sm flex-1 placeholder:text-[#5E4D5A]/60" />
        </form>
      </div>

      {products.length === 0 ? (
        <div className="relative overflow-hidden text-center py-20 rounded-2xl border border-dashed border-[#A8B59A] text-[#5E4D5A]" data-testid="shop-empty">
          <span className="relative">{q ? "No matching products." : "Our research catalog is coming soon."}</span>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {products.map((p) => (
            <Link key={p.id} to={`/product/${p.id}`} data-testid={`product-card-${p.id}`} className="bg-white rounded-2xl border border-[#A8B59A]/20 overflow-hidden hover:shadow-md hover:-translate-y-0.5 transition-transform transition-shadow duration-300 group">
              <ProductImage imageId={primaryImageId(p)} alt={p.name} iconSize={72} testId={`product-card-image-${p.id}`} />
              <div className="p-6">
                <h3 className="font-serif text-xl leading-tight group-hover:text-[#59394F] transition-colors">{p.name}</h3>
                <p className="text-xs text-[#5E4D5A] mt-1">{strengthsLabel(p)} · {p.form}</p>
                <div className="mt-4 flex items-end justify-between">
                  <p className="text-base font-medium" data-testid={`product-price-${p.id}`}>{priceLabel(p)}</p>
                  <p className="text-[10px] uppercase tracking-[0.2em] text-[#5E6B51]">RUO</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
    </div>
  );
}
